/**
 * Executes a function when it stops being invoked for n seconds
 */
export function debounce(callback: (args: IArguments) => void, delay: number, immediate?: boolean) {
	let timeout: ReturnType<typeof setTimeout>
	let result: void

	return function () {
		// eslint-disable-next-line prefer-rest-params
		const args = arguments

		const later = function () {
			timeout = null
			if (!immediate) {
				result = callback.apply(this, args)
			}
		}
		const callNow = immediate && !timeout

		clearTimeout(timeout)
		timeout = setTimeout(later, delay)

		if (callNow) {
			result = callback.apply(this, args)
		}

		return result
	}
}
